import Vue from "vue"; // 설치했던 fontawesome-svg-core와 vue-fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"; // 설치했던 아이콘파일에서 해당 아이콘만 불러옵니다.
import {
  faLink,
  faRedo,
  faUndo,
  faServer,
  faUserSecret,
  faCircle,
  faSync,
  faLaughWink,
  faChild,
  faUserFriends,
  faUsers,
  faHourglassHalf,
  faHourglassEnd,
  faSun,
  faCloud,
  faCloudSun,
  faUmbrella,
  faTemperatureHigh,
  faTemperatureLow,
  faWater,
  faMapMarkerAlt,
  faClock,
  faQuoteLeft,
} from "@fortawesome/free-solid-svg-icons";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons"; // 불러온 아이콘을 라이브러리에 담습니다.
import "font-awesome/css/font-awesome.min.css";
import { dom } from "@fortawesome/fontawesome-svg-core";

library.add(faTrashAlt);
library.add(
  faLink,
  faRedo,
  faUndo,
  faServer,
  faUserSecret,
  faCircle,
  faChild,
  faSync,
  faLaughWink,
  faUserFriends,
  faUsers,
  faHourglassHalf,
  faHourglassEnd,
  faSun,
  faCloud,
  faCloudSun,
  faUmbrella,
  faTemperatureHigh,
  faTemperatureLow,
  faWater,
  faMapMarkerAlt,
  faClock,
  faQuoteLeft
);

dom.watch();

Vue.component("font-awesome-icon", FontAwesomeIcon);
